export function productsSlider() {
    const $slider = $(".products-listing.slider .products");
    $slider.each(function () {
        let $this = $(this);
        $this.slick({
            slidesToScroll: 1,
            slidesToShow: 1.7,
            infinite: false,
            arrows: false,
            dots: true,
            autoplaySpeed: 4000,
            pauseOnHover: true,
            pauseOnFocus: true,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 1023,
                    settings: {
                        slidesToShow: 4,
                    }
                },
            ]
        }).on('afterChange', function (event, slick, currentSlide, nextSlide) {
            if ($this.find(".slick-dots .slick-active").index() == $this.find(".slick-dots li").length - 1) {
                setTimeout(function () {
                    $this.slick('slickGoTo', 0);
                }, 4000);
            }
        });
    });
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            let slider = $(entry.target);
            if (entry.isIntersecting) {
                slider.slick("slickPlay");
            } else {
                slider.slick("slickPause");
            }
        });
    });
    $slider.each(function () {
        observer.observe(this);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/productsSlider.js